import { ReactElement } from 'react';

import { ConfidentialResource } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { rowIndexKeyExtractor, Table } from '@dreryk/react-components';

import {
   useConfidentialResourcesTableColumns,
   useConfidentialResourcesTableDataConfiguration,
} from './ConfidentialResourcesTable.hooks';

type ConfidentialResourcesTableProps = {
   resources: ConfidentialResource[];
};

export const ConfidentialResourcesTable = (props: ConfidentialResourcesTableProps): ReactElement => {
   const columns = useConfidentialResourcesTableColumns();
   const dataConfiguration = useConfidentialResourcesTableDataConfiguration(props.resources);

   return (
      <Table<ConfidentialResource>
         testId={'confidentialResourcesTable'}
         dataConfiguration={dataConfiguration}
         columns={columns}
         keyExtractor={rowIndexKeyExtractor}
         compact
         pageSize={10}
      />
   );
};
